import { render, staticRenderFns } from "./edgeworkSelection.vue?vue&type=template&id=898de1c8&scoped=true&"
import script from "./edgeworkSelection.vue?vue&type=script&lang=js&"
export * from "./edgeworkSelection.vue?vue&type=script&lang=js&"
import style0 from "./edgeworkSelection.vue?vue&type=style&index=0&id=898de1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898de1c8",
  null
  
)

export default component.exports